import * as binderTypes from "../../enums/binderTypes.js";
import find from "lodash.find";

const PROFILE_TYPES = [
	binderTypes.CASE,
	binderTypes.COURT,
	binderTypes.DOCUMENT,
	binderTypes.FIRM,
	binderTypes.JUDGE,
	binderTypes.PARTY,
	binderTypes.PATENT,
	binderTypes.COPYRIGHT,
	binderTypes.TRADEMARK,
	binderTypes.EXPERT,
];

export default function isProfileBinder(binderType) {
	return !!find(PROFILE_TYPES, x => x === binderType);
}
